import React from "react";
import Multimedia from "./multimedia";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { motion } from "framer-motion";
import ArrowRight from "@default/assets/ui/arrow-right-visual-header.svg";
import Hyphenate from "@default/general-components/custom-hyphenation";
import { FormattedMessage } from "react-intl";
import useAccessibilityContext from "@default/js/accessibility/store/use-accessibility-context";
import TypewriterAnimation from "@default/general-components/typewriter-animation";
import { useSliderContext } from "@default/general-components/slider/context";

const REWRITE_MAP = {
  "Reeperbahn Festival": "Reeperbahn\nFestival",
};

const rewriteString = (str, map) => {
  return map[str] || str;
};

// Text reveals after the slide has had a moment to fade in, and hides
// immediately (no delay) once the slide is no longer active.
const TEXT_REVEAL_VARIANTS = {
  hidden: { opacity: 0, transition: { duration: 0.3 } },
  visible: {
    opacity: 1,
    transition: { duration: 0.3, delay: 0.5 },
  },
};

const VisualHeaderSlide = ({ content, index, single = false }) => {
  const { simpleDesign } = useAccessibilityContext();
  const { selectedIndex } = useSliderContext() ?? {};
  const isActive = single || selectedIndex === index;

  return (
    <div
      className={classNames("visual-header-slide", { single })}
      data-theme={content.fieldMainColors}
    >
      <div className="multimedia-wrapper">
        <Multimedia
          content={content.fieldMultimediaSingle}
          slideIndex={index}
        />
      </div>
      <Link
        className={classNames("text-wrapper", {
          link: content.fieldLink?.uri?.path,
        })}
        to={content.fieldLink?.uri?.path ?? "#"}
      >
        <motion.div
          className="text-wrapper-inner"
          initial="hidden"
          animate={isActive ? "visible" : "hidden"}
          variants={TEXT_REVEAL_VARIANTS}
        >
          {content.fieldSubheadline && (
            <span className="subheadline d-block headline-s">
              {content.fieldSubheadline}
            </span>
          )}
          {content.fieldTitlePrimary && (
            <h2
              className={classNames("title-primary headline-xxl mr-5", {
                "d-block d-md-inline": content.fieldTitleSecondary,
                "d-inline": !content.fieldTitleSecondary,
              })}
            >
              <Hyphenate>
                {rewriteString(content.fieldTitlePrimary, REWRITE_MAP)}
              </Hyphenate>
            </h2>
          )}

          {content.fieldTitleSecondary && (
            <span className="title-secondary headline-xxl headline-mono mr-5">
              <Hyphenate>{content.fieldTitleSecondary}</Hyphenate>
            </span>
          )}
          {content.fieldLink?.uri?.path && (
            <span
              className={classNames(
                "arrow-wrapper d-inline-flex align-items-baseline",
                {
                  themed: content.fieldTitleSecondary,
                }
              )}
            >
              {simpleDesign ? (
                <span className="simple-design-button standard">
                  <FormattedMessage id="read_more" />
                </span>
              ) : (
                <ArrowRight />
              )}
            </span>
          )}
        </motion.div>
      </Link>
    </div>
  );
};

export default VisualHeaderSlide;
